import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query';

import { cleanParams } from '@/utils/cleanParams';

import { apiAddressBookBffFetch } from '..';
import { ADDRESS_BOOK_BFF_QUERY_KEYS } from './queries';
import type {
  ContactHistoryRes,
  ContactListViewRes,
  GetContactHistoryParams,
  GetContactsViewParams,
} from './types';

export const _getBffContactsInfinite = (params?: Omit<GetContactsViewParams, 'page'>) =>
  infiniteQueryOptions({
    queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.contacts, 'infinite', ...Object.values(params ?? {})],
    queryFn: ({ pageParam = 1 }) =>
      apiAddressBookBffFetch<ContactListViewRes>('/contacts', {
        params: cleanParams({ ...params, page: pageParam, limit: 20 }),
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });

export const _getBffContactsBoardInfinite = (params?: Omit<GetContactsViewParams, 'page'>) =>
  infiniteQueryOptions({
    queryKey: [
      ADDRESS_BOOK_BFF_QUERY_KEYS.contacts,
      'infinite',
      'board',
      ...Object.values(params ?? {}),
    ],
    queryFn: ({ pageParam = 1 }) =>
      apiAddressBookBffFetch<ContactListViewRes>('/contacts', {
        params: cleanParams({ ...params, page: pageParam }),
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });

export const CONTACT_HISTORY_PAGE_SIZE = 30;

export const _getContactHistoryInfinite = (contactId: string, params?: GetContactHistoryParams) =>
  infiniteQueryOptions({
    queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.contactHistory, contactId, params ?? {}],
    queryFn: ({ pageParam }) =>
      apiAddressBookBffFetch<ContactHistoryRes>(`/contacts/${contactId}/history`, {
        params: cleanParams({
          includeSystem: false,
          limit: CONTACT_HISTORY_PAGE_SIZE,
          ...params,
          cursor: pageParam ?? undefined,
        }),
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    retry: 1,
  });
